module.exports = __webpack_public_path__ + "img/kv_sp.68b8717.jpg";